module.exports = __webpack_public_path__ + "static/media/class_small_demonhunter.27bc28b0.png";